import { render, staticRenderFns } from "./LandingMaster.vue?vue&type=template&id=315bf1a6&"
import script from "./LandingMaster.vue?vue&type=script&lang=js&"
export * from "./LandingMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports